export default __webpack_public_path__ + "static/media/Fiished_IMG_012_45.f67b92bd.jpg";